import type { SelectFc } from '@app/types/QueryOptions'
import type { FilterOption } from '@app/types/filter'
import type { RolesDirectorDto } from '@app/api/routes/monitoringLists/dtos'

export const getUsersOptionsFromEntity: SelectFc<FilterOption, RolesDirectorDto> = entityResponse =>
  entityResponse?.map(({ id, firstName, lastName }) => ({
    value: id,
    label: `${lastName} ${firstName}`
  })) ?? []
